import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { DELAY_FILTER_TIME } from "constants/RemoteDataTableContanst";
import { useListSaleTeams } from "hooks/sale-teams/useSaleTeams";
import { useHubList } from "hooks/hub-management/useHub";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { selectFilter, textFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DetailSaleTeams from "./DetailSaleTeams";
import {
  getInitSaleTeamsParams,
  saleTeamsHubOptions,
  saleTeamsRecordStatus,
  saleTeamsTypeOptions,
} from "./utils";

const ListSaleTeams = props => {
  const { t } = useTranslation(["saleTeams"]);

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);
  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  const [saleTeamsParams, setSaleTeamsParams] = useState(
    getInitSaleTeamsParams()
  );
  const [centerFilterDropdown, setCenterFilterDropdown] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState(null);

  const debounceTimeout = useRef(null);

  const {
    data: saleTeamsList,
    refetch: listSaleTeams,
    isLoading,
  } = useListSaleTeams({
    params: saleTeamsParams,
  });
  const { data: centersData } = useHubList({
    params: {
      page: 1,
      sizePerPage: 10,
      columnFilter: {
        "filter[is_center]": "1",
        "filter[record_status]": "O",
      },
      sort: "-maker_date",
      keywords: "",
      expand: "maker,checker",
      fields: "name,id",
    },
    enabled: true,
  });
  const onSuccessUpdate = () => {
    listSaleTeams();
  };
  const centerOptions = useMemo(() => {
    if (!centersData?.items) return [];
    return centersData.items.map(center => ({
      label: center.name,
      value: center.id,
    }));
  }, [centersData]);

  useEffect(() => {
    if (saleTeamsParams?.run) {
      listSaleTeams();
    }
  }, [saleTeamsParams]);

  useEffect(() => {
    setSaleTeamsParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      run: true,
    }));
    initColumn();
  }, [t]);

  const onSearchAllHandle = value => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setSaleTeamsParams(prev => ({
        ...prev,
        keywords: value,
        page: 1,
        run: true,
      }));
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  const initColumn = () => {
    const columns = [
      // {
      //   dataField: "code",
      //   text: t("table.code"),
      //   filter: textFilter({
      //     delay: DELAY_FILTER_TIME,
      //     placeholder: t("placeholder.enter", { title: t("table.code") }),
      //   }),
      //   sort: true,
      //   allowExport: true,
      // },
      {
        dataField: "name",
        text: t("table.name"),
        filter: textFilter({
          delay: DELAY_FILTER_TIME,
          placeholder: t("placeholder.enter", { title: t("table.name") }),
        }),
        sort: true,
        allowExport: true,
        style: {
          minWidth: "200px",
        },
      },
      {
        dataField: "hub",
        text: t("table.hub"),

        filter: selectFilter({
          placeholder: t("placeholder.select", {
            title: t("table.hub"),
          }),
          options: selectOptionsTable("hub"),
          className: "w-100",
        }),
        formatter: (cell, row) => {
          if (!row.hub?.name) {
            return (
              <BadgeForTable badgeColor="warning">
                Chưa được cấu hình
              </BadgeForTable>
            );
          }
          return row.hub?.name;
        },
        sort: true,
        allowExport: true,
      },
      {
        dataField: "record_status",
        text: t("table.record_status"),
        sort: true,
        align: "center",
        headerStyle: { width: "160px" },
        filter: selectFilter({
          placeholder: t("placeholder.select", {
            title: t("table.record_status"),
          }),
          options: selectOptionsTable("record_status"),
        }),
        formatter: (cell, row) => {
          const status = saleTeamsRecordStatus.find(item => item.key === cell);
          if (status) {
            return (
              <BadgeForTable badgeColor={status.badgeColor}>
                {status.label}
              </BadgeForTable>
            );
          }
          return "";
        },
        allowExport: true,
      },
      {
        dataField: "type",
        text: t("table.type"),
        sort: true,
        align: "center",
        headerStyle: { width: "160px" },
        filter: selectFilter({
          placeholder: t("placeholder.select", {
            title: t("table.type"),
          }),
          options: selectOptionsTable("type"),
        }),
        formatter: (cell, row) => {
          const typeOption = saleTeamsTypeOptions.find(
            item => item.key === cell
          );
          if (typeOption) {
            return typeOption.label;
          }
          return "";
        },
        allowExport: true,
      },
      {
        dataField: "note",
        text: t("table.note"),
        sort: false,
        allowExport: true,
      },
    ];

    setColumnsTable(columns);
  };
  const selectOptionsTable = (name = "") => {
    const select = {};
    switch (name) {
      case "record_status":
        saleTeamsRecordStatus.forEach(item => {
          select[item.key] = item.label;
        });
        break;
      case "hub":
        saleTeamsHubOptions.forEach(item => {
          select[item.key] = item.label;
        });
        break;
      case "type":
        saleTeamsTypeOptions.forEach(item => {
          select[item.key] = item.label;
        });
        break;
      default:
        break;
    }
    return select;
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    const column_filter = columnFilter || {};

    const transformedFilters = {};
    Object.keys(column_filter).forEach(key => {
      if (key === "filter[hub]") {
        transformedFilters["hub_name"] = column_filter[key];
      } else if (key === "filter[hub][like]") {
        transformedFilters["hub_name"] = column_filter[key];
      } else if (key === "filter[code][like]") {
        transformedFilters["filter[code]"] = column_filter[key];
      } else if (key === "filter[type]") {
        transformedFilters["filter[type]"] = column_filter[key];
      } else {
        transformedFilters[key] = column_filter[key];
      }
    });

    const cleanedFilters = {};
    Object.keys(transformedFilters).forEach(key => {
      const value = transformedFilters[key];
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value !== " "
      ) {
        cleanedFilters[key] = value;
      }
    });

    // const parent_hub_name = cleanedFilters["filter[parent_hub_id][like]"];
    // delete cleanedFilters["filter[parent_hub_id][like]"];

    setSaleTeamsParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : prev.sort,
      columnFilter: cleanedFilters,
      // parent_hub_name: parent_hub_name,
      page: page || 1,
      sizePerPage: sizePerPage || 10,
      run: true,
    }));
  };

  const toggleDetailModal = () => {
    setDetailModal(!detailModal);
  };

  const onClickUpdate = (row, index) => {
    setDataDetail(row);
    setMode("update");
    toggleDetailModal();
  };

  const handleCenterFilter = center => {
    setSelectedCenter(center);
    setCenterFilterDropdown(false);

    const newColumnFilter = { ...saleTeamsParams.columnFilter };

    if (center) {
      newColumnFilter["filter[hub_id]"] = center.value;
    } else {
      delete newColumnFilter["filter[hub_id]"];
    }

    setSaleTeamsParams(prev => ({
      ...prev,
      page: 1,
      columnFilter: newColumnFilter,
      run: true,
    }));
  };

  const listRowAction = [
    {
      icon: <i className="fas fa-pen fa-lg text-primary ms-2" />,
      text: t("table.actions.update"),
      onClick: onClickUpdate,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.manager")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={`${t("title.manager")} (${saleTeamsList?.totalCount || 0})`}
            breadcrumbItems={[
              { name: t("title.manager") },
              { name: "Danh sách Sale Teams" },
            ]}
          />

          <Row>
            <Col className="col-12">
              <DetailSaleTeams
                dataDetail={dataDetail}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
              />
            </Col>

            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    keyField="id"
                    data={saleTeamsList?.items || []}
                    columns={columnsTable}
                    page={saleTeamsParams.page}
                    sizePerPage={saleTeamsParams.sizePerPage}
                    totalSize={saleTeamsList?.totalCount || 0}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    listRowAction={listRowAction}
                    loading={isLoading}
                  >
                    <Dropdown
                      isOpen={centerFilterDropdown}
                      toggle={() =>
                        setCenterFilterDropdown(!centerFilterDropdown)
                      }
                    >
                      <DropdownToggle className="btn primary-btn" caret>
                        {t("table.hub")}
                        {selectedCenter ? (
                          <span>: {selectedCenter.label}</span>
                        ) : (
                          <span>: Tất cả</span>
                        )}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => handleCenterFilter(null)}>
                          Tất cả
                        </DropdownItem>
                        {centerOptions.map(center => (
                          <DropdownItem
                            key={center.value}
                            onClick={() => handleCenterFilter(center)}
                          >
                            {center.label}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListSaleTeams;
